import { store, getContext } from "@wordpress/interactivity";

const { state } = store("filterable-pubblicazioni", {
  state: {
    get filteredPosts() {
      const { posts, activeTerm, searchQuery } = state;
      const q = searchQuery.trim().toLowerCase();

      return posts.filter((p) => {
        if (activeTerm !== 0 && !p.term_ids.includes(activeTerm)) return false;
        if (q && !p.titolo.toLowerCase().includes(q)) return false;
        return true;
      });
    },

    get visibleIds() {
      return new Set(
        state.filteredPosts.slice(0, state.visibleCount).map((p) => p.id),
      );
    },

    get getItemDisplay() {
      const { postId } = getContext();
      return state.visibleIds.has(postId) ? "block" : "none";
    },

    get emptyDisplay() {
      return state.filteredPosts.length === 0 ? "block" : "none";
    },

    get loadMoreDisplay() {
      return state.filteredPosts.length > state.visibleCount ? "flex" : "none";
    },

    get isTermActive() {
      const { termId } = getContext();
      return state.activeTerm === termId;
    },
  },

  actions: {
    setTerm() {
      const { termId } = getContext();
      state.activeTerm = termId;
      state.visibleCount = state.perPage;
    },

    setSearch(event) {
      state.searchQuery = event.target.value;
      state.visibleCount = state.perPage;
    },

    loadMore() {
      state.visibleCount += state.perPage;
    },
  },
});
